import React from 'react';

import moment from 'moment/moment';

export default function VenueDayDetails({ details, daysSchedules }) {
    return (
        <div>
            <div>{$t('Details about athlete number')}</div>
            <div>
                <div className="tw-grid tw-grid-cols-4 tw-gap-2">
                    {daysSchedules.length > 1 && (
                        <div className="tw-col-auto">
                            <span className="tw-text-xs tw-text-charcoal">{$t('Date')}</span>
                        </div>
                    )}
                    <div className="tw-col-auto">
                        <span className="tw-text-xs tw-text-charcoal">{$t('1st Session start')}</span>
                    </div>
                    <div className="tw-col-auto">
                        <span className="tw-text-xs tw-text-charcoal">{$t('Final Session finish')}</span>
                    </div>
                    <div className="tw-col-auto">
                        <span className="tw-text-xs tw-text-charcoal">{$t('Total duration')}</span>
                    </div>
                </div>
                {daysSchedules.map((schedule, index) => (
                    <div key={index} className="tw-grid tw-grid-cols-4 tw-gap-2">
                        {daysSchedules.length > 1 && (
                            <div className="tw-col-auto">
                                <span>{moment(schedule.date).format('DD/MM/YY')}</span>
                            </div>
                        )}
                        <div className="tw-col-auto">
                            <span>{schedule.start}</span>
                        </div>
                        <div className="tw-col-auto">
                            <span>{schedule.end}</span>
                        </div>
                        <div className="tw-col-auto">
                            <span>{schedule.duration}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
